import { LitElement, html, nothing } from 'lit';
import { t } from '../i18n';
import {
  loadRuntimeCapabilities,
  subscribeRuntimeCapabilities,
  type RuntimeCapabilitySnapshot,
} from '../runtime-capabilities';
import { defineZenComponent } from './register';

/**
 * The user menu is legacy markup, but the optional workspace entry is a Lit
 * projection so the deployment capability cannot leave a stale static button
 * behind while config is loading or unavailable.
 */
class ZenWorkspaceMenuItem extends LitElement {
  static properties = {
    enabled: { state: true },
  };

  declare enabled: boolean;

  private unsubscribeCapabilities: (() => void) | null = null;

  constructor() {
    super();
    this.enabled = false;
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.unsubscribeCapabilities = subscribeRuntimeCapabilities(this.onCapabilitiesChanged);
    document.addEventListener('zen-lang-change', this.onLangChange);
    void loadRuntimeCapabilities();
  }

  disconnectedCallback() {
    this.unsubscribeCapabilities?.();
    this.unsubscribeCapabilities = null;
    document.removeEventListener('zen-lang-change', this.onLangChange);
    super.disconnectedCallback();
  }

  private onCapabilitiesChanged = (snapshot: RuntimeCapabilitySnapshot) => {
    this.enabled = snapshot.status === 'ready' && snapshot.capabilities.workspace_admin === true;
  };

  private onLangChange = () => this.requestUpdate();

  private navigate = () => {
    location.hash = '#settings-members';
    this.dispatchEvent(new CustomEvent('workspace-menu-selected', { bubbles: true, composed: true }));
  };

  render() {
    if (!this.enabled) return nothing;
    return html`
      <button id="workspaceMenuBtn" @click=${this.navigate}>
        <span class="mi mi-sm">groups</span> <span data-i18n="workspaceMenuItem">${t('workspaceMenuItem')}</span>
      </button>
    `;
  }
}

defineZenComponent('zen-workspace-menu-item', ZenWorkspaceMenuItem);
